import React from 'react';

const SelectInput = (props) => {
  return (
    <div
      className="mt-2 p-4 pt-2"
      style={{ display: 'flex', flexDirection: 'column' }}
    >
      <span
        style={{
          fontSize: '12px',
          fontWeight: 500,
        }}
      >
        {props.title}
      </span>
      <select
        style={{
          border: '1px solid #A5A6BB',
          borderRadius: '12px',
          height: '48px',
          padding: '0px 16px',
        }}
        value={props.value}
        onChange={(e) =>
          props.onChange((d) => {
            return { ...d, [props.name]: e.target.value };
          })
        }
      >
        <option
          value=""
          disabled=""
          style={{ fontSize: '2px', fontWeight: 500 }}
        >
          Select a procedure
        </option>
        <option disabled="">Proctology</option>
        <option value="Piles">Piles</option>
        <option value="Fissure">Fissure</option>
        <option value="Fistula">Fistula</option>
        <option value="Pilonidal-Sinus">Pilonidal Sinus</option>
        <option disabled="">Laparoscopy</option>
        <option value="Hernia">Hernia</option>
        <option value="Gallstones">Gallstones</option>
        <option value="Appendicitis">Appendicitis</option>
        <option value="Rectal-Prolapse">Rectal Prolapse</option>
        <option value="Bariatric-Surgery">Bariatric Surgery</option>
        <option value="GERD-Achalasia">GERD/Achalasia</option>
        <option disabled="">Ophthalmology</option>
        <option value="Lasik">Lasik</option>
        <option value="Cataract">Cataract</option>
        <option value="Glaucoma">Glaucoma</option>
        <option value="Cornea-Retina">Cornea &amp; Retina</option>
        <option value="Squint-Corrections">Squint Corrections</option>
        <option disabled="">ENT</option>
        <option value="Adenoidectomy">Adenoidectomy</option>
        <option value="Tonsillectomy">Tonsillectomy</option>
        <option value="Septoplasty">Septoplasty/ DNS</option>
        <option value="Sinus-Surgery">Sinus Surgery</option>
        <option value="Mastoid-Surgeryy">Mastoid Surgery</option>
        <option value="Pediatric-ENT">Pediatric ENT Surgery</option>
        <option value="Obstructive-Apnea">
          Obstructive Sleep Apnea Surgery
        </option>
        <option disabled="">Vascular Surgery</option>
        <option value="Varicose-Veins-Laser-Treatment">
          Varicose Veins Laser Treatment
        </option>
        <option value="Deep-Vein-Thrombosis-(DVT)">
          Deep Vein Thrombosis (DVT)
        </option>
        <option value="AV-Fistula">AV Fistula</option>
        <option value="Spider-Veins">Spider Veins</option>
        <option value="Varicocele">Varicocele</option>
        <option disabled="">Orthopaedics</option>
        <option value="Total-Knee-Replacement">Total Knee Replacement</option>
        <option value="Total-Hip-Replacement">Total Hip Replacement</option>
        <option value="ACL/PCL-Injuries">ACL/PCL Injuries</option>
        <option value="Shoulder-Injuries">Shoulder Injuries</option>
        <option value="Spinal-Injuries">Spinal Injuries</option>
        <option value="Carpal-tunnel">Carpal tunnel syndrome</option>
        <option disabled="">Fertility</option>
        <option value="IVF">IVF</option>
        <option value="IUI">IUI</option>
        <option value="male-infertility">Male infertility treatment</option>
        <option value="female-infertility">Female infertility treatment</option>
        <option disabled="">Urology</option>
        <option value="Kidney-Stones">Kidney Stones</option>
        <option value="Enlarged-Prostate-(BPH)">Enlarged Prostate (BPH)</option>
        <option value="Hydrocele">Hydrocele</option>
        <option value="Circumcision">Circumcision</option>
        <option value="Vasectomy">Vasectomy</option>
        <option value="Enlarged-Prostate">Enlarged Prostate/TURP</option>
        <option disabled="">Gynecology</option>
        <option value="Hysterectomy">Hysterectomy</option>
        <option value="Natural/C-Section">
          Natural &amp; C-Section Delivery
        </option>
        <option value="Abortion-DNC">Abortion/ DNC</option>
        <option value="Endometriosis">Endometriosis Surgery</option>
        <option value="PCOD-PCOS">PCOD/ PCOS Treatment</option>
        <option value="Uterine-Fibroids">Uterine Fibroids</option>
        <option value="Vaginal-Cyst">Bartholin Cyst/ Vaginal Cyst</option>
        <option value="Tubal-Ligation">Tubal Ligation</option>
        <option disabled="">General Surgery</option>
        <option value="Diabetic-Ulcers">Diabetic Foot Ulcers</option>
        <option value="Abscess">Abscess</option>
        <option value="Thyroid-Surgery">Thyroid Surgery</option>
        <option value="Breast-Surgery">Breast Surgery</option>
        <option disabled="">Aesthetics</option>
        <option value="Gynecomastia">Gynecomastia</option>
        <option value="Lipoma">Lipoma/ Liposuction</option>
        <option value="Rhinoplasty">Rhinoplasty/ Nose Contouring</option>
        <option value="Dental-Aligners">Dental Aligners</option>
        <option value="Hair-Transplant">Hair Transplant / PRP treatment</option>
        <option value="Breast-Augmentation">
          Breast Augmentation/ Reduction
        </option>
        <option value="Botox">Face Lift / Botox</option>
        <option value="Mole-Removal">Mole Removal</option>
        <option value="Hymenoplasty">Hymenoplasty</option>
      </select>
      {props.error && (
        <span
          className="pt-1"
          style={{
            fontSize: '12px',
            fontWeight: 500,
            color: '#767787',
          }}
        >
          {props.error}
        </span>
      )}
    </div>
  );
};

export default SelectInput;
